import { render } from "./WalletList.vue?vue&type=template&id=90a53e8a"
import script from "./WalletList.vue?vue&type=script&lang=js"
export * from "./WalletList.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__